import axios from 'axios';
import md5 from 'js-md5'
const API_URL = process.env.VUE_APP_API+'auth';

const config = {
  headers: {
    "Content-Type": "application/json; charset=utf-8"
  },
  withCredentials: true,
  crossOrigin: true
}

class AuthService {
  login(user) {
    return axios
      .post(API_URL + '/signin/?login='+user.username, {
        login: user.username,
        password: md5(user.password)
      }, config)
      .then(response => {
        if (response.data.username && response.data.roles.includes('cashier')) {
          sessionStorage.setItem('user', JSON.stringify(response.data));
        }

        return response.data;
      });
  }

  logout() {
    sessionStorage.removeItem('user');
    localStorage.removeItem('lang');
    return axios.post(API_URL + '/signout/');
  }

  register(user) {
    return axios.post(API_URL + 'signup', {
      username: user.username,
      email: user.email,
      password: user.password
    });
  }
}

export default new AuthService();
